import React, { useState } from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import { sortBy } from "lodash-es";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom-v5-compat";
import * as yup from "yup";

import { SelectField } from "../app/Atoms/Form";
import guides from "../assets/images/welcome_journey/guidesScreenShot.png";
import supportChat from "../assets/images/welcome_journey/support_chat.png";
import { ContentBlock, TwoColumnPage, Testimonial, InfoPage } from "./Atoms";
import { Form, RadioSelectField, TextField, TextArea, Button } from "./Form";
import countriesData from "./country_info/countriesData";
import { useJourney } from "./sign_up_journeys";

const schema = yup
  .object({
    talkToSomeone: yup.string().ensure().required("Please select an answer"),
  })
  .required();

export const TalkingToUs = () => {
  const { t } = useTranslation();
  return (
    <InfoPage title={t("comms.talkingToUsTitle")}>
      <ContentBlock
        subTitle={t("comms.support_title")}
        content={[
          <div className="items-center gap-16 space-y-12 pt-24 sm:flex sm:space-y-0">
            <div>{t("comms.support_content")}</div>
            <img
              className="mx-auto rounded shadow sm:w-1/2"
              src={supportChat}
            />
          </div>,
        ]}
      />
      <ContentBlock
        subTitle={t("comms.guides_title")}
        content={[
          false && (
            <div className="flex-col items-center gap-16 pt-24">
              <img className="rounded shadow sm:w-3/5" src={guides} />
              <div>
                {t("comms.guides_content.0")}
                {t("comms.guides_content.1")}
              </div>
            </div>
          ),

          <img className="mx-auto rounded shadow sm:w-4/5" src={guides} />,
          <div>
            <Trans t={t} i18nKey="comms.guides_content.0" />
            <br />
            {t("comms.guides_content.1")}
          </div>,
        ]}
      />
    </InfoPage>
  );
};
const FurtherQuestionsForm = ({}) => {
  const { t } = useTranslation();
  const {
    saveJourney,
    journey,
    formProps: { handleSubmit, ...formProps },
  } = useJourney({ resolver: yupResolver(schema) });

  const navigate = useNavigate();
  const onSubmit = async (data) => {
    if (data.talkToSome == "yes") {
      window.Intercom("show");
    }
    await saveJourney(data);
    navigate("../ready-to-see-more");
  };
  const onWantingToTalk = (e) => {
    const value = e.target.value;
    if (value === "today") {
      navigate("#request-a-call");
    }
  };

  const country = countriesData[journey.countryCode];
  const subcountry = formProps.watch("subcountry");
  return (
    <Form
      onSubmit={handleSubmit(onSubmit)}
      className="flex flex-col items-center space-y-48"
    >
      <h1 className="text-center">{t("formContent.furtherQuestionsTitle")}</h1>
      <input
        type="hidden"
        value="book-a-chat"
        {...formProps.register("currentPage")}
      />
      <RadioSelectField
        label={t("formContent.talkToSomeone")}
        onChange={onWantingToTalk}
        name="talkToSomeone"
        options={[
          { value: "today", label: t("formContent.yesTalkToSomeoneToday") },
          { value: "tomorrow", label: t("formContent.tomorrow") },
          { value: "no", label: t("formContent.noTalkToSomeone") },
        ]}
        formProps={formProps}
      />
      <TextField
        formProps={formProps}
        name="phoneNumber"
        label={t("formContent.phoneNumber")}
      />
      {country && (
        <div className="flex w-full justify-evenly space-x-8">
          <div className="flex-1">
            <SelectField
              name="subcountry"
              label={t("formContent.subcountry")}
              options={[
                { value: null, label: null },
                ...Object.keys(country)
                  .sort()
                  .map((subcountry) => ({
                    value: subcountry,
                    label: subcountry,
                  })),
              ]}
              formProps={formProps}
            />
          </div>
          <div className="flex-1">
            <SelectField
              name="city"
              label={t("formContent.city")}
              options={[
                { value: null, label: null },
                ...sortBy(country[subcountry] || [], "name").map(
                  ({ name }) => ({
                    value: name,
                    label: name,
                  }),
                ),
              ]}
              formProps={formProps}
            />
          </div>
        </div>
      )}
      <TextArea
        formProps={formProps}
        name="furtherQuestions"
        label={t("formContent.anythingElse")}
        helpText={t("formContent.anythingElse_helpText")}
      />
      <Testimonial
        quote={<Trans t={t} i18nKey="testimonial.frankHsu.quote" />}
        name={t("testimonial.frankHsu.name")}
        venue={t("testimonial.frankHsu.venue")}
      />
      <div className="text-center">
        <Button primary>{t("furtherQuestions.nextButton")}</Button>
      </div>
    </Form>
  );
};
const FurtherQuestionsPage = ({ progress }) => {
  return (
    <TwoColumnPage
      progress={progress}
      left={<TalkingToUs />}
      right={<FurtherQuestionsForm />}
    />
  );
};

export default FurtherQuestionsPage;
